<div class="profile-container">
    <div class="">
      <div class="profile-content">
        <div class="personal-details">
          <h4 class="personal-details-title">Product Category List</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of productCategoryList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count};let i = index">
                <th scope="col">{{product.productCategoryId}}</th>
                <th scope="col">{{product.name}}</th>
                <th scope="col">{{product.description}}</th>
                <th>
                    <i class="bi bi-trash3" (click)="selectProductCategory(product.id)" data-toggle="modal" data-target="#deleteModal"></i>
                </th>
              </tr>
            </tbody>
          </table>
          <div class="pagination-block" *ngIf="productCategoryList.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Conformation!!
                <span data-dismiss="modal">
                    <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>are you sure? want to delete??</p>   
                <div class="modal-footer">
                <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" (click)="deleteProductCategory()" class="btn btn-primary">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>